import { lazyWithRetry } from '../../utils/lazy-with-retry';

const Logout = lazyWithRetry(() => import('./logout'), 'Logout');
const AuthCallback = lazyWithRetry(() => import('./auth-callback'), 'AuthCallback');
const Blocked = lazyWithRetry(() => import('./blocked'), 'Blocked');
const LoginV2 = lazyWithRetry(() => import('./login-v2'), 'LoginV2');
const SignupV2 = lazyWithRetry(() => import('./signup-v2'), 'SignupV2');
const UpdatePassword = lazyWithRetry(() => import('./update-password'), 'UpdatePassword');
const ForgotPassword = lazyWithRetry(() => import('./forgot-password'), 'ForgotPassword');
const AcceptInvitation = lazyWithRetry(() => import('./accept-invitation'), 'AcceptInvitation');
const NewTeamMemberSignup = lazyWithRetry(() => import('./new-team-member-signup'), 'NewTeamMemberSignup');
const ConfirmSignup = lazyWithRetry(() => import('./confirm-signup'), 'ConfirmSignup');
const RateLimited = lazyWithRetry(() => import('./rate-limited'), 'RateLimited');
const OAuthConsent = lazyWithRetry(() => import('./oauth-consent'), 'OAuthConsent');

export {
  Logout,
  AuthCallback,
  Blocked,
  LoginV2,
  SignupV2,
  UpdatePassword,
  ForgotPassword,
  AcceptInvitation,
  NewTeamMemberSignup,
  ConfirmSignup,
  RateLimited,
  OAuthConsent
};

